import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { LOCALE_PREFIXES } from "../lib/locale";
import NotFoundPage from "../pages/NotFoundPage";

export default function LocaleLayout() {
    const { lang } = useParams();
    const { language, setLanguage } = useLanguage();
    const valid = LOCALE_PREFIXES.includes(lang);

    useEffect(() => {
        if (valid && language !== lang) setLanguage(lang);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lang, valid]);

    if (!valid) return <NotFoundPage />;
    return <Outlet />;
}
